<template>
  <div class="product-information__marking-container">
    <oie-base-label v-if="newsSection" is-type="new" :text="newsSection"></oie-base-label>

    <oie-base-label v-if="section" is-type="info" :text="section"></oie-base-label>

    <oie-base-label
      v-if="campaignTag"
      is-type="campaign"
      :text="campaignTag"></oie-base-label>

    <a
      v-if="productBrand && productBrandLink"
      :href="productBrandLink"
      target="_blank"
      rel="noopener noreferrer">
      <oie-base-image
        v-tooltip.right="productBrandTooltip"
        :images="getAssetPath(manufacturerLogo(productBrand))"
        :alt-text="productBrand"
        image-height="4rem"
        class="product-information__brand-logo"></oie-base-image>
    </a>

    <oie-base-image
      v-else-if="productBrand"
      v-tooltip.right="productBrandTooltip"
      :images="getAssetPath(manufacturerLogo(productBrand))"
      :alt-text="productBrand"
      image-height="4rem"
      class="product-information__brand-logo"></oie-base-image>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    newsSection: {
      type: String,
      default: null
    },
    section: {
      type: String,
      default: null
    },
    productBrand: {
      type: String,
      default: null
    },
    productBrandTooltip: {
      type: String,
      default: null
    },
    productBrandLink: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('commerce', ['currentProduct']),
    campaignTag () {
      return this.currentProduct && this.currentProduct.items[0] && this.currentProduct.items[0].customerPrice && this.currentProduct.items[0].customerPrice.campaignTag ? this.currentProduct.items[0].customerPrice.campaignTag : ''
    }
  },
  methods: {
    manufacturerLogo(manufacturer) {
      if (manufacturer === '' || manufacturer == null) {
        return
      }

      return `/globalassets/brands/${manufacturer}.jpg`
    }
  }
}
</script>

<style lang="scss">
.product-information__marking-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.product-information__marking-container > * {
  margin-bottom: measure(quarter);
}

.product-information__brand-logo {
  width: auto;
  max-height: 1.8rem;
}
</style>
